import React from 'react';

import { Alert, Drawer, TextLink } from '@grafana/ui';

import { PLUGIN_ROOT } from 'consts';

interface Props {
  onClose: () => void;
  editJobId?: string;
}

export function InteractiveForecastDrawer({ onClose, editJobId }: Props) {
  const path = editJobId ? `${editJobId}/edit` : 'create';
  const linkText = editJobId ? 'edit this forecast' : 'create a forecast';
  return (
    <Drawer title="Interactive forecast creator" size="sm" onClose={onClose}>
      <div>
        <Alert title="This tool is in public preview!" severity="info" />
        <p>This tool lets you create and fine-tune a metric forecast.</p>
        <p>
          After selecting your metric, you can preview and interact with the forecast live in your browser in order to
          judge how good a forecast is created. If you are happy, you create the forecast job which is then created and
          maintained by Grafana Cloud.
        </p>
        <p>There are some caveats to be aware of however:</p>
        <ul>
          <li>
            The preview forecast is performed on lower resolution data than the forecast performed by Grafana Cloud, so
            there may be minor differences in results.
          </li>
          <li>
            Some options are not supported by our preview form at this time. If you need additional options, you can{' '}
            <TextLink href={`${PLUGIN_ROOT}/metric-forecast/${path}`}>{linkText}</TextLink> using our original form.
            Specifically, the preview forecast does not support holidays or many of the advanced model options yet.
          </li>
        </ul>
      </div>
    </Drawer>
  );
}
